import Bluebird from 'bluebird';
import $ from 'jquery';
import { clearBillingAccountId, inIframe, isTest } from '../../services/app-storage';
import { clearSessionItem, getSessionItem, setSessionItem } from '../../services/browser-storage';
import { loadCountryCode } from '../../services/country-code';
import loadMoment from '../../services/moment-utils';
import { hasReloaded } from '../../services/navigation';
import { getUrlParam } from '../../services/url-params';
import { loadBillingAccount } from '../bundle/billing-account/billing-account-loader';
import detectBrowser from '../bundle/browser-detection';
import { loadCurrency } from '../bundle/currencies/currency-loader';
import { Sentry } from '../bundle/sentry';
import loadDatePickers from './datepicker';
import { loadErrors } from './errors/errors';
import { fillFieldsByUrlData } from './field-filler';
import activateFlightInfoButton, { activateInfoButton } from './flight-info-btn';
import { loadFlightnumber } from './flightnumber';
import loadUnibars from './input-fields/unibar/unibar-loader';
import loadInputs from './inputs-loader';
import { loadModeSwitcher } from './mode-switcher';
import { loadReturn } from './return';
import loadSession from './session/session-load';
import { loadStopover } from './stopover';
import { loadSubmit } from './submit/submit';
import getUrlData from './url-data-reader';
import loadValidations from './validation/validation-loader';

export default async function loadWidget(): Bluebird<void> {
    Bluebird.config({ warnings: false });

    if (!Modernizr.localstorage || !Modernizr.sessionstorage) {
        console.log('Local/Session storage is not enabled!');
    }

    if (!isTest) Sentry.configure();

    detectBrowser();

    // Header visibility
    // TODO: Handle this in the portal
    const showHeader = !getUrlParam('noheader') && !getSessionItem('noheader');
    if (showHeader) {
        $('html').addClass('show-header');
    }

    // Language picker visibility
    const hideLanguagePickerKey = 'hideLanguagePicker';
    const hideLanguagePicker = getUrlParam('hideLocaleUI') || getSessionItem(hideLanguagePickerKey);

    if (hideLanguagePicker) {
        setSessionItem(hideLanguagePickerKey, 'true');
    } else {
        $('html').addClass('show-language-picker');
        clearSessionItem(hideLanguagePickerKey);
    }

    // Store URL params in sessionstorage
    const wl = getUrlParam('whitelabel');
    const noheader = getUrlParam('noheader');

    if (wl) {
        setSessionItem('whitelabel', wl);
        if (noheader) setSessionItem('noheader', noheader);
    }

    if (inIframe) {
        // For Chrome 66 background scrolling bug workaround
        document.documentElement.classList.add('in-frame');
    }

    clearBillingAccountId();

    const urlData = getUrlData();

    // Store session vars
    const { email, passengerName, reference, apiUrl } = urlData;
    if (email) setSessionItem('u_email', email);
    if (passengerName) setSessionItem('u_passenger-name', passengerName);
    if (reference) setSessionItem('u_reference', reference);
    if (apiUrl) setSessionItem('api-url', apiUrl);

    // Load form
    await Bluebird.all([
        loadUnibars(),
        loadCountryCode(),
        loadCurrency(),
        loadMoment(),
        loadValidations(),
        loadDatePickers(),
        loadErrors(),
        loadInputs(),
        loadModeSwitcher(),
        loadReturn(),
        loadStopover(),
        loadSubmit(),
        loadFlightnumber(),
        activateFlightInfoButton(),
        activateInfoButton('billing-info-btn', 'billing-info-content')
    ]);

    loadBillingAccount();

    // Prefill fields from session
    if (hasReloaded()) {
        console.log('Not loading session');
    } else {
        await loadSession();
    }

    // Prefill fields from URL
    await fillFieldsByUrlData(urlData);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/_loader.ts